import React, { useContext, useState } from "react";
import TableLayout from '../table-layout/hoa-table-layout';
import SuccessMessage from "../success-message/hoa-success-message";
import FilteringComponenet from "../filtering-component/hoa-filtering-comp";

import config from "../../hoa-config";
import { GlobalContext } from '../../context/hoa-global-context';
import dashboardServices from "../../services/hoa-dashboard-api-service";
import LinearProgress from "@mui/material/LinearProgress";
import datastore from "../../store/hoa-datastore";

export default function RequestsDashboard() {
    const {requests, updateRequestsData, selectedValues, updateSelectedValues } = useContext<any>(GlobalContext);
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState('');
    const [view, setView] = useState('list');
    const [loading, setLoading] = useState(false);

    const headers = config.dashboard['Requests']?.tableLayout?.title;
    const columns = config.dashboard['Requests']?.tableLayout?.columns;
    const filteringTitle = config.dashboard['Requests']?.filterComponent?.title;
    const filteringSubTitle = config.dashboard['Requests']?.filterComponent?.subTitle;

    const getRequests = async (numberOfRequests: number, pageNo: number) => {
		const { data } = await dashboardServices.getRequests(numberOfRequests, pageNo, requests.options, datastore.selectedOrganization?.id);
		return {
            data: data.hoaRequests,
            count: data.parseCount,
        };
	};

    const updateRequest = async (objectId: string, newStatus: string) => {
        if(!objectId || !newStatus) {
            return;
        }

        let data = JSON.parse(JSON.stringify(requests.data));
        let updateIndex = 0;
        data.find((value: any, index: number) => {
            if(value.objectId === objectId){
                updateIndex = index;
            }
        });
        var updatedRequest = JSON.parse(JSON.stringify(data[updateIndex]));
        updatedRequest.status = newStatus;
        setLoading(true);
        const result = await dashboardServices.updateRequestStatus(updatedRequest.objectId, updatedRequest);
        setLoading(false);
        
        if(result.status == 200 && result.data) {
            data[updateIndex] = result.data;
            updateRequestsData({
                ...requests,
                data
            });
        }
    }

    const removeRequestData = async (request: any) => {
        let data = requests?.data.filter((item: any, index: number) => item.objectId != request.objectId)

        const res = await dashboardServices.removeRequest(request.objectId);
        if(res.status === 200){
            updateRequestsData({
                ...requests,
                data: data,
                fetchingFilteredData: true
            });
            setSuccess(true);
            setMessage('Request removed successfully');
        }
    }

    return (
        <>
             {
                view === 'list' ?
                <>
                    <FilteringComponenet
                        onAddClick={setView}
                        title={filteringTitle}
                        subTitle={filteringSubTitle}
                        tagType={"Requests"}
                    />
                    {loading ? <LinearProgress style={{ height: "2px" }} /> : null}
                    <TableLayout
                        fetchResult={getRequests}
                        headers={headers}
                        columns={columns}
                        tagType={"Requests"}
                        updateView={setView} 
                        updateSelectedValues={updateSelectedValues}
                        updateRequest={updateRequest}
                        removeRequestData={removeRequestData}
                    />
                    <SuccessMessage
                        success={success}
                        setSuccess={setSuccess}
                        message={message}
                    />  
                </>
                :<></>
            }
        </>

    )
}